module.exports = __webpack_public_path__ + "img/kungfuheroes-large.78677ec2.jpg";